import type { Requests } from "../common/request.common";
import type { ProvisionReturnResponseTypes } from "../common/response.common";
import { get, post } from "./common";

export const provisionReturn = {
    record(data: typeof Requests.ProvisionReturn.Record.Input) {
        return post<typeof data, ProvisionReturnResponseTypes.Record>(
            `/provision-return/record`,
            data,
        );
    },
    obtain(id: string) {
        return get<ProvisionReturnResponseTypes.Obtain>(`/provision-return/obtain/${id}`);
    },
    finish(id: string, data: typeof Requests.ProvisionReturn.Finish.Input) {
        return post<typeof data>(`/provision-return/finish/${id}`, data);
    },
};
